import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { initializeOrders, useOrders } from "@/05-models/order";
import { useErrorNotify } from "@/06-shared/lib/errorNotifier";
import { CreateOrder } from "@/04-features/create-order";
import { ShowOrderItem } from "@/04-features/show-order-item";
import styles from "./index.module.css";
export const OrdersFeed = () => {
    const orders = useOrders();
    const [isLoading, setIsLoading] = useState(true);
    const showError = useErrorNotify();
    useEffect(() => {
        initializeOrders()
            .catch(showError)
            .finally(() => setIsLoading(false));
    }, []);
    return (_jsxs("section", { className: styles.feed, children: [_jsxs("div", { className: styles.header, children: [_jsx("h1", { className: styles.title, children: "\u0417\u0430\u044F\u0432\u043A\u0438" }), _jsx(CreateOrder, {})] }), _jsxs("div", { className: styles.content, children: [isLoading && (_jsx("p", { className: styles.message, children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0437\u0430\u044F\u0432\u043E\u043A..." })), (!isLoading && orders.length === 0) && (_jsx("p", { className: styles.message, children: "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0437\u0430\u044F\u0432\u043E\u043A \u043D\u0435\u0442" })), orders.map((order) => (_jsx(ShowOrderItem, { order: order }, order.id)))] })] }));
};
